import React from 'react'
import { Nav } from 'react-bootstrap'
import { Link, useLocation } from 'react-router-dom'
import { useTranslation } from "react-i18next"
import { useSelector } from 'react-redux'

export default function SidebarClub({ isCollapsed }) {
	const { t } = useTranslation()
	const location = useLocation()
	const {club} = useSelector(state=>state.clubs)

	const isActive = (path) => {
		return location.pathname.includes(path)
	}

  	return (
		<div className={`sidebar ${isCollapsed ? 'collapsed' : ''}`} id="sidebar">
			<Link to="/">
				<img 
					src={isCollapsed ? '/images/logotipo-reducido-movil.svg' : '/images/logotipo-sdplay-cabecera.svg'} 
					id="logo-menu" 
					alt='Logotipo SDPlay' 
				/>
			</Link>
			<Nav className="flex-column p-0">
				<Nav.Item>
					<Link 
						to={`/${t("url.club.club")}/${t("url.club.dashboard")}`}
						className={isActive(t("url.club.dashboard")) ? 'active' : ''}
					>
						<img src="/images/menus/dashboard.svg" alt={t('menus.general.dashboard')}/> 
						{!isCollapsed && t('menus.general.dashboard')}
					</Link>
				</Nav.Item>
				<Nav.Item className='disabled'>
					<Link to="/#" onClick={(e) => e.preventDefault()}>
						<img src="/images/menus/members.svg" alt={t('menus.general.clients')}/> 
						{!isCollapsed && t('menus.general.clients')}
					</Link>
				</Nav.Item>
				<Nav.Item>
					<Link 
						to={`/${t("url.club.club")}/${t("url.club.payments")}`}
						className={isActive(t("url.club.payments")) ? 'active' : ''}
					>
						<img src="/images/menus/payments.svg" alt={t('menus.general.payments')}/> 
						{!isCollapsed && t('menus.general.payments')}
					</Link>
				</Nav.Item>
				{
					club?.activitybooking
					?
						<>
							<Nav.Item>
								<Link 
									to={`/${t("url.club.club")}/${t("url.club.activities")}`}
									className={isActive(t("url.club.activities")) ? 'active' : ''}
								>
									<img src="/images/menus/activities.svg" alt={t('menus.general.activities')}/> 
									{!isCollapsed && t('menus.general.activities')}
								</Link>
							</Nav.Item>
							<Nav.Item>
								<Link 
									to={`/${t("url.club.club")}/${t("url.club.promotions")}`}
									className={isActive(t("url.club.promotions")) ? 'active' : ''}
								>
									<img src="/images/menus/promotions.svg" alt={t('menus.general.promotions')}/> 
									{!isCollapsed && t('menus.general.promotions')}
								</Link>
							</Nav.Item>
						</>
					:
						<></>
				}
				<Nav.Item>
					<Link 
						to={`/${t("url.club.club")}/${t("url.club.sites")}`}
						className={isActive(t("url.club.sites")) ? 'active' : ''}
					>
						<img src="/images/menus/sites.svg" alt={t('menus.general.sites')}/> 
						{!isCollapsed && t('menus.general.sites')}
					</Link>
				</Nav.Item>
				{
					club?.renting
					?
					<>
						<Nav.Item>
							<Link 
								to={`/${t("url.club.club")}/${t("url.club.courts")}`}
								className={isActive(t("url.club.courts")) ? 'active' : ''}
							>
								<img src="/images/menus/sites.svg" alt={t('menus.general.courts')}/> 
								{!isCollapsed && t('menus.general.courts')}
							</Link>
						</Nav.Item>
						<Nav.Item>
							<Link 
								to={`/${t("url.club.club")}/${t("url.club.courtsrents")}`}
								className={isActive(t("url.club.courtsrents")) ? 'active' : ''}
							>
								<img src="/images/menus/calendar.svg" alt={t('menus.general.courtsrents')}/> 
								{!isCollapsed && t('menus.general.courtsrents')}
							</Link>
						</Nav.Item>
					</>
					:
					<></>
				}
				{
					club?.ticketing
					?
						<Nav.Item>
							<Link 
								to={`/${t("url.club.club")}/${t("url.club.seasons")}`}
								className={isActive(t("url.club.seasons")) ? 'active' : ''}
							>
								<img src="/images/menus/ticketing.svg" alt={t('menus.general.ticketing')}/> 
								{!isCollapsed && t('menus.general.ticketing')}
							</Link>
						</Nav.Item>
					:
						<></>
				}
				<Nav.Item className='disabled'>
					<Link to="/#" onClick={(e) => e.preventDefault()}>
						<img src="/images/menus/reports.svg" alt={t('menus.general.reports')}/> 
						{!isCollapsed && t('menus.general.reports')}
					</Link>
				</Nav.Item>
				<Nav.Item className='disabled'>
					<Link to="/#" onClick={(e) => e.preventDefault()}>
						<img src="/images/menus/billing.svg" alt={t('menus.general.billing')}/> 
						{!isCollapsed && t('menus.general.billing')}
					</Link>
				</Nav.Item>
				<Nav.Item>
					<Link 
						to={`/${t("url.club.club")}/${t("url.club.logs")}/${t("url.club.sepalogs")}`}
						className={isActive(t("url.club.sepalogs")) ? 'active' : ''}
					>
						<img src="/images/menus/config.svg" alt={t('menus.general.sepalogs')}/> 
						{!isCollapsed && t('menus.general.sepalogs')}
					</Link>
				</Nav.Item>
				<Nav.Item>
					<Link 
						to={`/${t("url.club.club")}/${t("url.club.basicdata")}`}
						className={isActive(t("url.club.basicdata")) ? 'active' : ''}
					>
						<img src="/images/menus/config.svg" alt={t('menus.general.config')}/> 
						{!isCollapsed && t('menus.general.config')}
					</Link>
				</Nav.Item>
			</Nav>
		</div>
	)
}